module.exports = __webpack_public_path__ + "img/img_nav_cooperate-w.556c2e8f.svg";